import React, { useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  IconButton,
  Tooltip,
  InputAdornment
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';

const initialContacts = [
  {
    sno: 1,
    name: 'John Doe',
    mobile: '+91 9876543210',
    email: 'john.doe@email.com',
    message: 'I need help with my account setup and password reset',
    entryDate: '2025-10-10',
  },
  {
    sno: 2,
    name: 'Jane Smith',
    mobile: '+91 9876543211',
    email: 'jane.smith@email.com',
    message: 'Inquiry about your services and pricing plans',
    entryDate: '2025-10-09',
  },
  {
    sno: 3,
    name: 'Mike Johnson',
    mobile: '+91 9876543212',
    email: 'mike.johnson@email.com',
    message: 'Technical support needed for mobile application',
    entryDate: '2025-10-08',
  },
];

const QuickContactUs = () => {
  const [contacts, setContacts] = useState(initialContacts);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  const handleDelete = (contactSno) => {
    if (window.confirm('Are you sure you want to delete this contact?')) {
      setContacts(contacts.filter(contact => contact.sno !== contactSno));
    }
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredContacts = contacts.filter(contact =>
    contact.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    contact.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
    contact.mobile.includes(searchTerm)
  );

  return (
    <Box sx={{ p: 3 }}>
      {/* Heading Section */}
      <Box sx={{ mb: 3 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography variant="h4" component="h1" gutterBottom>
              Quick Contact List
            </Typography>
          </Grid>
          <Grid item xs={12} md={6} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <TextField
              placeholder="Search contacts..."
              size="small"
              value={searchTerm}
              onChange={handleSearch}
              sx={{ minWidth: 300 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
      </Box>

      {/* Table Details Section */}
      <Paper elevation={3} sx={{ p: 3 }}>
        <Typography variant="h6" sx={{ mb: 3 }}>
          Contact Inquiries
        </Typography>
        <Typography variant="body2" color="primary" sx={{ mb: 3, fontWeight: 'bold' }}>
          Total Records: {filteredContacts.length}
        </Typography>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }}>S.No</TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }}>Name</TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }}>Mobile</TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }}>Email</TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }}>Message</TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }}>Entry Date</TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredContacts
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((contact, idx) => (
                  <TableRow
                    key={contact.sno}
                    sx={{
                      '&:nth-of-type(odd)': { backgroundColor: '#fafafa' },
                      '&:hover': { backgroundColor: '#e3f2fd' }
                    }}
                  >
                    <TableCell>{contact.sno}</TableCell>
                    <TableCell>
                      <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
                        {contact.name}
                      </Typography>
                    </TableCell>
                    <TableCell>{contact.mobile}</TableCell>
                    <TableCell>
                      <Typography variant="body2" sx={{ color: 'primary.main' }}>
                        {contact.email}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" sx={{ maxWidth: '250px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {contact.message}
                      </Typography>
                    </TableCell>
                    <TableCell>{contact.entryDate}</TableCell>
                    <TableCell>
                      <Tooltip title="Delete Contact">
                        <IconButton
                          color="error"
                          onClick={() => handleDelete(contact.sno)}
                          sx={{ 
                            '&:hover': { 
                              backgroundColor: 'error.light',
                              color: 'white' 
                            }
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={filteredContacts.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50]}
          sx={{ mt: 2 }}
        />
      </Paper>
    </Box>
  );
};

export default QuickContactUs;